<template>
	<div>
		<SentimentKlineDay title="市场情绪" subText="节点把控" modal="0"></SentimentKlineDay>
		<SentimentKlineDay title="市场人气" subText="参考节点" modal="20"></SentimentKlineDay>

		<SentimentMarketHotDay zoom_start="45"></SentimentMarketHotDay>
		<!-- <v-chart class="my-chart" :options="bar" /> -->
		<!-- <div>{{polar}}</div> -->
	</div>
</template>

<script>
		
	import SentimentKlineDay from 'components/sentiment/SentimentKlineDay.vue'
	import SentimentMarketHotDay from 'components/sentiment/SentimentMarketHotDay.vue'
	
	export default {
		components: {
			SentimentKlineDay,
			SentimentMarketHotDay,
		},
		data() {
			return {
				
			}
		}
	}
</script>

<style scoped>

</style>
